<div class='totals-handle'>
  <h5>
    <nb-icon class='totals-icon' icon='pie-chart' nbPrefix pack='eva'></nb-icon>
    {{ 'TOTALS.TITLE' | translate }}
  </h5>
</div>
<nb-card>
  <nb-card-header [ngClass]='{ full: full }' class='edit-totals'>
    <div>
      <app-full-status-led [full]='full'></app-full-status-led>
    </div>
    <div></div>
    <!--    <div>-->
    <!--      <button-->
    <!--        (click)='toggleEditMode()'-->
    <!--        *ngIf='!editing'-->
    <!--        class='edit-button'-->
    <!--        nbButton-->
    <!--        size='small'-->
    <!--      >-->
    <!--        {{ 'BUTTONS.EDIT' | translate }}-->
    <!--        <nb-icon icon='edit-2'></nb-icon>-->
    <!--      </button>-->
    <!--      <button-->
    <!--        (click)='cancelEditMode()'-->
    <!--        *ngIf='editing'-->
    <!--        class='edit-button'-->
    <!--        nbButton-->
    <!--        size='small'-->
    <!--      >-->
    <!--        {{ 'BUTTONS.CANCEL' | translate }}-->
    <!--        <nb-icon icon='close-outline' pack='eva'></nb-icon>-->
    <!--      </button>-->
    <!--      <button-->
    <!--        (click)='saveTotalsForm()'-->
    <!--        *ngIf='editing'-->
    <!--        [ngClass]='{ editing: editing }'-->
    <!--        class='edit-button'-->
    <!--        nbButton-->
    <!--        size='small'-->
    <!--      >-->
    <!--        {{ 'BUTTONS.SAVE' | translate }}-->
    <!--        <nb-icon icon='edit-2'></nb-icon>-->
    <!--      </button>-->
    <!--    </div>-->
  </nb-card-header>
  <nb-card-body class='totals-card'>
    <div *ngIf='totals | async as occupation' class='row totals-card-body'>
      <div class='col'>
        <div class='row justify-content-center chart-container'>
          <div class='chart'>
            <div *ngIf='editing' [ngClass]='{ editing: editing }' class='chart chart-overlay'></div>
            <div [initOpts]='initOps' [options]='chartOption' class='echart' echarts></div>
          </div>
        </div>
      </div>
      <div [nbSpinner]='savingForm'
           class='col total-amounts'
           nbSpinnerSize='large' nbSpinnerStatus='info'>
        <form [formGroup]='totalsForm' class='totals-form'>
          <div *ngFor='let ratios of occupation.occupationRatios; let i = index'>
            <div class='occupation-number-row'>
              <div class='alarm-led'>
                <app-alarm-led
                  [ledConfig]='{
                    label: false,
                    color: getCategoryColor(occupation.occupationRatios[i].type.id, occupation.occupationRatios[i].ratio),
                    tiny: false
                  }'
                  class='alarm-led'
                ></app-alarm-led>
              </div>
              <div>
                <span *ngIf='(!editing || !occupation.occupationRatios[i].adjustable) && editMode === 0'
                      class='occupation'>{{occupation.occupationRatios[i].occupation}}</span>
                <span *ngIf='(!editing || !occupation.occupationRatios[i].adjustable) && editMode === 1'
                      class='occupation'>{{occupation.occupationRatios[i].capacity - occupation.occupationRatios[i].occupation}}</span>
                <input *ngIf='(editing && occupation.occupationRatios[i].adjustable)'
                       class='input-totals'
                       fieldSize='small'
                       formControlName='ctrlOccupation{{occupation.occupationRatios[i].type.id}}'
                       name='occupation'
                       nbInput
                       type='number'
                       value='{{occupation.occupationRatios[i].occupation}}'>
                {{ 'TOTALS.OUT_OFF' | translate }} {{occupation.occupationRatios[i].capacity}}<br>
                <span class='label'>
                <span
                  *ngIf='occupation.occupationRatios[i].editMode === 0'>{{ 'TOTALS.EDIT_MODE_0' | translate }}</span>
                <span
                  *ngIf='occupation.occupationRatios[i].editMode === 1'>{{ 'TOTALS.EDIT_MODE_1' | translate }}</span>
                  {{occupation.occupationRatios[i].type.name}}</span>
              </div>
            </div>
            <div class='occupation-number-row'>
              <div *ngIf='occupation.reservationOccupationRatios[i]' class='alarm-led'>
                <app-alarm-led
                  [ledConfig]='{
                    label: false,
                    color: getCategoryColor(occupation.reservationOccupationRatios[i].type.id, occupation.reservationOccupationRatios[i].ratio),
                    tiny: false
                  }'
                  class='alarm-led'
                ></app-alarm-led>
              </div>
              <div *ngIf='occupation.reservationOccupationRatios[i]'>
                <span *ngIf='!editing || !occupation.reservationOccupationRatios[i].adjustable'
                      class='occupation'>{{occupation.reservationOccupationRatios[i].occupation}}</span>
                <input *ngIf='editing && occupation.reservationOccupationRatios[i].adjustable'
                       class='input-totals'
                       fieldSize='small'
                       formControlName='ctrlReservation{{occupation.reservationOccupationRatios[i].type.id}}'
                       name='occupation'
                       nbInput
                       type='number'
                       value='{{occupation.reservationOccupationRatios[i].occupation}}'>
                {{ 'TOTALS.OUT_OFF' | translate }} {{occupation.reservationOccupationRatios[i].allocation}}<br>
                <span class='label'>{{ 'TOTALS.RESERVED' | translate }}
                  ({{occupation.reservationOccupationRatios[i].type.name}})</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </nb-card-body>
</nb-card>
<!--{{chartOption|json}}-->
<!--{{totals}}-->
